import PosterCTA from './PosterCTA';

export default PosterCTA;
